import { InboxOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

const DraggerInputBodyIconWrapper = styled.div`
  font-size: 48px;
  color: ${props => props.theme.colorPrimary};
  line-height: 1;
`;
const TitleWrapper = styled.div`
  font-size: 16px;
  color: ${props => props.theme.colorText};
  line-height: 1;
`;
const InfoWrapper = styled.div`
  font-size: 14px;
  line-height: 1;
  color: ${props => props.theme.colorTextTertiary};
`;

export interface DraggerInputBodyProps {
  title?: React.ReactNode;
  info?: React.ReactNode;
}

export function DraggerInputBody(props: DraggerInputBodyProps) {
  const { title, info } = props;
  const { t } = useTranslation();

  return (
    <Space direction="vertical" align="center">
      <DraggerInputBodyIconWrapper>
        <InboxOutlined aria-hidden />
      </DraggerInputBodyIconWrapper>
      <TitleWrapper>
        {title ??
          t(
            'inputs.dragger-input-body.title',
            'Fare clic o trascinare il file in quest’area per caricarlo',
          )}
      </TitleWrapper>
      <InfoWrapper>{info}</InfoWrapper>
    </Space>
  );
}
